export const defaultBody = {
	nombre: '',
	estatus: 'A',
};

export const newBodyForm = [
	{
		label: 'Nombre del Órgano Colegiado',
		name: 'nombre',
		type: 'text',
	},
];

export const editBodyForm = [
	{
		label: 'Nombre del Órgano Colegiado',
		name: 'nombre',
		type: 'text',
	},
];


